import {
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Form, Formik } from 'formik';
import { withSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom';
import InputWithFormik from '../../../../components/inputs/InputWithFormik';
import FinalButtons from '../../../../FinalButtons';
import FinalButtonsMobile from '../../../../FinalButtonsMobile';
import axios from '../../../../utils/axios';
import { Yup } from '../../../../utils/form-utils';
import FormikSubmitEffect from '../FormikSubmitEffect';

const useStyles = makeStyles(theme => ({
  container: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  paper: {
    // marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    // marginLeft: theme.spacing(6),
    // marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
      padding: theme.spacing(0),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(5)
    }
  },
  inputGroup: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

const validationSchema = Yup.object().shape({
  nombre: Yup.string().required(),
  apellido: Yup.string().required(),
  nroDocumento: Yup.string().required()
});

const PersonaEditForm = props => {
  const { enqueueSnackbar } = props;
  const {
    params: { id }
  } = useRouteMatch();
  const formik = useRef();
  const classes = useStyles();
  const [loadingSendPre, setLoadingSendPre] = useState(false);
  const history = useHistory();
  const myRef = useRef(null);
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const [baseObject, setBaseObject] = useState({
    nombre: '',
    apellido: '',
    nroDocumento: ''
  });

  const gridProps = {
    spacing: 3,
    className: classes.inputGroup
  };

  const onSubmitError = () => {
    enqueueSnackbar('Verificar formatos y campos obligatorios', {
      variant: 'warning'
    });
  };

  const enviar = async () => {
    const { values } = formik.current;
    setLoadingSendPre(true);
    try {
      // setTouched({}, false);
      const valuesToSend = Object.assign({}, values);
      try {
        const metodo = id ? 'actualizar' : 'crear';
        await axios.post(`persona/${metodo}`, valuesToSend);
        enqueueSnackbar('Guardado correctamente', { variant: 'success' });
        history.push('/personas');
      } catch (err) {
        console.log(err);

        enqueueSnackbar(
          err?.response?.data?.message || 'Error al intentar guardar',
          {
            variant: 'error'
          }
        );
      }

      setLoadingSendPre(false);
    } catch (error) {
      console.log(error);
      setLoadingSendPre(false);
    }
  };

  const onSubmit = () => {
    enviar();
  };

  const handleBack = () => {
    history.push('/personas');
  };

  const buttonProps = {
    okText: id ? 'Actualizar' : 'Guardar',
    cancelText: 'Volver',
    handleBack,
    isPhone,
    classes,
    loadingSendPre
  };

  const Buttons = () =>
    isPhone ? (
      <FinalButtonsMobile {...buttonProps} />
    ) : (
      <FinalButtons {...buttonProps} />
    );

  const loadData = async idParam => {
    const response = await axios.get(`persona/${idParam}`);
    const nuevosDatos = { ...response.data };
    setBaseObject(prev => ({ ...prev, ...nuevosDatos }));
  };

  useEffect(
    () => {
      loadData(id);
    },
    [id]
  );

  return (
    <div>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={8}>
          <div ref={myRef} style={{ height: 16 }} />
          <Container maxWidth="md" style={{ marginLeft: 0 }}>
            <div style={{ paddingBottom: 40 }}>
              <Grid container item>
                <Typography variant="h6" gutterBottom>
                  Formulario de carga de Persona
                </Typography>
              </Grid>
              <Formik
                enableReinitialize
                initialValues={baseObject}
                validationSchema={validationSchema}
                innerRef={formik}
                onSubmit={onSubmit}
              >
                {() => (
                  <>
                    <FormikSubmitEffect
                      onSubmitError={onSubmitError}
                      validationSchema={validationSchema}
                    />
                    <Form noValidate>
                      <Grid container {...gridProps}>
                        <Grid container item>
                          <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            gutterBottom
                          >
                            Datos de la persona que entregará las mercaderías
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <InputWithFormik
                            label="Nombre"
                            name="nombre"
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <InputWithFormik
                            label="Apellido"
                            name="apellido"
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <InputWithFormik
                            label="Número de documento"
                            name="nroDocumento"
                            required
                          />
                        </Grid>
                      </Grid>
                      <Buttons />
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </Container>
        </Paper>
      </div>
    </div>
  );
};

export default withSnackbar(PersonaEditForm);
